import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { FanRankListParams, FetchFanListParams } from '@module/apis/client-side/fan/type';

export const fanQueryKeys = createQueryKeys('fan', {
  fetchFanList: (fetchFanListParams: FetchFanListParams) => [fetchFanListParams],
  fetchFanRankList: (fetchMyFanListParams: FanRankListParams) => [fetchMyFanListParams],
  fetchFanRankWrite: () => ['fanRankWrite'],
  fetchFanRankCancel: () => ['fanRankCancel'],
});
